export function averageFetchPerGame() {
  const fetchCounts = JSON.parse(localStorage.getItem('total_fetches') || '[]');
  const totalFetchCount = fetchCounts.reduce((acc, count) => acc + count, 0);
  const avgFetchCount = fetchCounts.length > 0 ? totalFetchCount / fetchCounts.length : 0;

  const avgFetchCountString = avgFetchCount.toFixed(1);
  const avgFetchCountLimited = parseFloat(avgFetchCountString);
  const tempAvgGuesses = avgFetchCountLimited;

  return tempAvgGuesses;
}

export function averageFetchPerGameCries() {
  const fetchCounts = JSON.parse(localStorage.getItem('total_fetches_cries') || '[]');
  const totalFetchCount = fetchCounts.reduce((acc, count) => acc + count, 0);
  const avgFetchCount = fetchCounts.length > 0 ? totalFetchCount / fetchCounts.length : 0;

  const avgFetchCountString = avgFetchCount.toFixed(1);
  const avgFetchCountLimited = parseFloat(avgFetchCountString);
  const tempAvgGuesses = avgFetchCountLimited;

  return tempAvgGuesses;
}

export function averageFetchPerGameEmoji() {
  const fetchCounts = JSON.parse(localStorage.getItem('total_fetches_emoji') || '[]');
  const totalFetchCount = fetchCounts.reduce((acc, count) => acc + count, 0);
  const avgFetchCount = fetchCounts.length > 0 ? totalFetchCount / fetchCounts.length : 0;

  const avgFetchCountString = avgFetchCount.toFixed(1);
  const avgFetchCountLimited = parseFloat(avgFetchCountString);
  const tempAvgGuesses = avgFetchCountLimited;

  return tempAvgGuesses;
}
